import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import Cookies from 'js-cookie'
import axios, { setCurrentUserTimezone, setCurrentCurrencyCode } from '@/lib/axios'
import { getErrorMessage } from '@/lib/utils'
import { SuccessResponseType } from '@/types/general'

type LogoutStateType = {
  isLoading: boolean
  error: {
    status?: number
    message: string
  } | null
}

type LogoutStoreType = {
  logoutState: LogoutStateType
  logout: () => Promise<SuccessResponseType>
  reset: () => void
}

const initialState: LogoutStateType = {
  isLoading: false,
  error: null
}

const useLogoutStore = create<LogoutStoreType>()(
  devtools(set => ({
    logoutState: initialState,
    logout: async () => {
      set(() => ({
        logoutState: {
          ...initialState,
          isLoading: true
        }
      }))

      try {
        const { data } = await axios.get<SuccessResponseType>('/auth/logout')

        // Clear cookies
        Cookies.remove('accessToken')
        Cookies.remove('refreshToken')
        Cookies.remove('rememberMe')

        // Clear timezone and currency
        setCurrentUserTimezone(null)
        setCurrentCurrencyCode(null)

        set(() => ({
          logoutState: initialState
        }))

        return data
      } catch (error: any) {
        set(() => ({
          logoutState: {
            isLoading: false,
            error: {
              status: error.response?.status || 500,
              message: getErrorMessage(error)
            }
          }
        }))

        throw error
      }
    },
    reset: () => {
      set(() => ({
        logoutState: initialState
      }))
    }
  }))
)

export default useLogoutStore
